import { anyOf, arrayOf, enumOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string, nullValidation } from "@altostra/type-validations/lib/primitives";

import SharedConstants from "@lib/shared_constants";

import type { GlobalFunnelRun } from "./types";

export const isGlobalFunnelRun = objectOf<GlobalFunnelRun>({
  id: string,
  status: enumOf("pending", "running", "completed", "failed"),
  results: anyOf(arrayOf(objectOf({ step: number, user_count: number })), nullValidation),
  error_message: anyOf(string, nullValidation),
  error_code: maybe(anyOf(enumOf(SharedConstants.GLOBAL_FUNNEL_REPORTS.ERRORS.TIMEOUT), nullValidation)),
});
